export default __webpack_public_path__ + "static/media/rv_dark.82aa1723.png";